import React, { useEffect, useState } from 'react'
import {
  Button,
  createStyles,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
  Theme,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { TermsController } from '../../../../../shared/controllers/ TermsController'

interface SearchBarProps {
  getBatchOfMachineTypes
  companyId
  history
  selectedLanguage
}

export const SearchBar = ({
  getBatchOfMachineTypes,
  companyId,
  history,
  selectedLanguage,
}: SearchBarProps) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      searchbar: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
      },
      textfield: {
        margin: 0,
        width: 200,
        backgroundColor: 'white',
      },
      button: {
        width: 200,
        borderRadius: '10px',
        backgroundColor: '#1c8033',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#1c8033',
        },
      },
    })
  )
  const classes = useStyles()

  const [searchValue, setSearchValue] = useState('')
  const [searchProperty, setSearchProperty] = useState('name')

  const getLabel = (key) => {
    const labels = {
      name: 'Name',
    }
    return labels[key]
  }

  const termsController = new TermsController()

  return (
    <div className={classes.searchbar}>
      <TextField
        className={classes.textfield}
        size="small"
        name="test"
        id="searchValue"
        label={getLabel(searchProperty)}
        variant="filled"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            getBatchOfMachineTypes(searchValue, searchProperty, true, companyId)
          }
        }}
      />

      <FormControl variant="filled" size="small">
        <InputLabel htmlFor="outlined-age-native-simple">
          {
            {
              de: 'Suche nach',
              en: 'Search',
              fr: 'Suche nach - FR',
            }[selectedLanguage]
          }
        </InputLabel>
        <Select
          className={classes.textfield}
          native
          label="Suche"
          value={searchProperty}
          onChange={(e) => setSearchProperty(e.target.value as string)}
          inputProps={{
            name: 'searchProperty',
            id: 'searchProperty',
          }}
        >
          <option value="name">Name</option>
        </Select>
      </FormControl>

      <Button
        className={classes.button}
        startIcon={<SearchIcon />}
        onClick={() =>
          getBatchOfMachineTypes(searchValue, searchProperty, true, companyId)
        }
      >
        {
          {
            de: 'Suchen',
            en: 'Search',
            fr: 'Suchen - FR',
          }[selectedLanguage]
        }
      </Button>

      {window.localStorage.getItem('loggedInUserRole') === 'admin' ||
      window.localStorage.getItem('loggedInUserRole') ===
        'manufacturerAdmin' ? (
        <Button
          className={classes.button}
          onClick={() => history.push(`/createNewMachineType/${companyId}`)}
        >
          {termsController.getTerm('+ Maschinentyp', selectedLanguage) ||
            {
              de: '+ Maschinentyp',
              en: '+ Machinetype',
              fr: '+ Maschinentyp - FR',
            }[selectedLanguage]}
        </Button>
      ) : null}
    </div>
  )
}
